import { useId } from 'react'
import { useLang } from '../i18n'
import { useTheme } from '../theme'
import { THEMES, TEXT_SCALES } from '../lib/appearance-options'

/**
 * The Settings page's Appearance section — a SECOND, independent surface from the TopBar
 * account-menu's own compact Theme/Text-size popover (unchanged, see TopBar.tsx). Same
 * THEMES/TEXT_SCALES data (lib/appearance-options.ts) and the same useTheme() state, but rendered
 * as two real `<fieldset>`/`<legend>` groups of native radios, side by side (.settings-appearance-col
 * in styles.css): on a full page there is no need for the popover's bespoke roving-tabindex
 * keyboard handling — the browser's own radio-group behavior (arrow keys move the selection, Tab
 * leaves the group) already does the job.
 */
export function AppearanceSection() {
  const { t } = useLang()
  const { theme, setTheme, textScale, setTextScale } = useTheme()
  const themeGroupId = useId()
  const scaleGroupId = useId()

  return (
    <div className="settings-appearance">
      <fieldset className="settings-card settings-appearance-col">
        <legend>{t('theme_group_label')}</legend>
        {THEMES.map((th) => {
          const id = `${themeGroupId}-${th.id}`
          return (
            <label key={th.id} className="export-radio" htmlFor={id}>
              <input
                id={id}
                type="radio"
                name="account-settings-theme"
                checked={theme === th.id}
                onChange={() => setTheme(th.id)}
              />
              {t(th.label)}
            </label>
          )
        })}
      </fieldset>

      <fieldset className="settings-card settings-appearance-col">
        <legend>{t('textscale_group_label')}</legend>
        {TEXT_SCALES.map((ts) => {
          const id = `${scaleGroupId}-${ts.id}`
          return (
            <label key={ts.id} className="export-radio" htmlFor={id}>
              <input
                id={id}
                type="radio"
                name="account-settings-textscale"
                checked={textScale === ts.id}
                onChange={() => setTextScale(ts.id)}
              />
              {t(ts.label)}
            </label>
          )
        })}
      </fieldset>
    </div>
  )
}
